module.exports = __webpack_public_path__ + "img/notification1.d363c8f4.png";